(function () {
  function getMoneyFormat() {
    return window.tuftzyMoneyFormat || (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, getMoneyFormat());
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format((cents || 0) / 100);
    } catch (error) {
      return '$' + (((cents || 0) / 100).toFixed(2));
    }
  }

  function rootUrl(path) {
    var prefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return prefix + String(path || '').replace(/^\//, '');
  }

  function parseJsonScript(scope, selector) {
    var node = scope.querySelector(selector);
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  }

  function fetchCart() {
    return fetch(rootUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }

  function changeLine(lineKey, quantity) {
    return fetch(rootUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update cart');
      return response.json();
    });
  }

  function addVariant(variantId, quantity) {
    return fetch(rootUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add item');
      return response.json();
    });
  }

  function lineCompareAt(item) {
    var compare = item.original_price || item.original_line_price || 0;
    var final = item.final_price || item.final_line_price || item.line_price || 0;
    if (compare > final) return compare;
    return 0;
  }

  function discountUrl(code) {
    if (!code) return rootUrl('checkout');
    return rootUrl('discount/' + encodeURIComponent(code) + '?redirect=/checkout');
  }

  function lineImage(item) {
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    if (item.image) return item.image;
    return 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  
  function renderLineItemProperties(properties) {
    if (!properties || typeof properties !== 'object') return '';
    var entries = Object.entries(properties).filter(function(pair) {
      return !String(pair[0]).startsWith('_') && pair[1] !== '';
    });
    if (!entries.length) return '';
    return entries.map(function(pair) {
      return '<span class="tuftzy-cart-chip">' + escapeHtml(pair[0]) + ': ' + escapeHtml(pair[1]) + '</span>';
    }).join('');
  }

  function buildItemBenefits(config) {
    if (!config || !config.default_benefits || !config.default_benefits.length) return '';
    return config.default_benefits.map(function (item) {
      return '<span class="tuftzy-cart-chip">' + escapeHtml(item) + '</span>';
    }).join('');
  }

  function renderSummaryMarkup(cart, promoCode, config) {
    var rows = '';
    rows += '<div class="tuftzy-summary-row"><span>Subtotal</span><strong>' + formatMoney(cart.items_subtotal_price || cart.total_price || 0) + '</strong></div>';
    rows += '<div class="tuftzy-summary-row"><span>Shipping</span><strong>' + escapeHtml(config.shipping_label || 'Free') + '</strong></div>';

    if ((cart.total_discount || 0) > 0) {
      rows += '<div class="tuftzy-summary-row tuftzy-summary-savings"><span>You save</span><strong>-' + formatMoney(cart.total_discount) + '</strong></div>';
    }

    if (promoCode) {
      rows += '<div class="tuftzy-summary-row"><span>Promo code</span><strong>' + escapeHtml(promoCode) + '</strong></div>';
    }

    rows += '<div class="tuftzy-summary-total"><span>Total</span><strong>' + formatMoney(cart.total_price || 0) + '</strong></div>';
    rows += '<div class="tuftzy-note">' + escapeHtml(config.taxes_note || 'Taxes and any eligible discounts are calculated at checkout.') + '</div>';
    return rows;
  }

  function lineVariantText(item) {
    return item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
  }

  function estimateMonthly(totalCents, divisor) {
    var by = Number(divisor || 24);
    if (!by || by < 1) by = 24;
    return formatMoney(Math.round((totalCents || 0) / by));
  }

  function CartPage(root) {
    this.root = root;
    this.config = parseJsonScript(root, '[data-tuftzy-config]');
    this.cart = null;
    this.promoCode = '';
    this.elements = {
      list: root.querySelector('[data-cart-list]'),
      summary: root.querySelector('[data-summary-rows]'),
      mobileSummary: root.querySelector('[data-mobile-summary]'),
      mobileSummaryTotal: root.querySelector('[data-mobile-summary-total]'),
      heroTotal: root.querySelector('[data-hero-total]'),
      monthly: root.querySelector('[data-monthly-payment]'),
      promoInput: root.querySelector('[data-promo-input]'),
      promoStatus: root.querySelector('[data-promo-status]'),
      checkoutPrimary: root.querySelector('[data-checkout-button]'),
      continueShopping: root.querySelector('[data-continue-shopping]'),
      recommendations: root.querySelector('[data-recommendations]')
    };
    this.bind();
  }

  CartPage.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      var remove = event.target.closest('[data-remove-item]');
      var addRec = event.target.closest('[data-add-recommendation]');
      var mobileToggle = event.target.closest('[data-mobile-summary-toggle]');

      if (minus) {
        event.preventDefault();
        self.updateQuantity(minus.getAttribute('data-line-key'), Number(minus.getAttribute('data-next-quantity')));
        return;
      }

      if (plus) {
        event.preventDefault();
        self.updateQuantity(plus.getAttribute('data-line-key'), Number(plus.getAttribute('data-next-quantity')));
        return;
      }

      if (remove) {
        event.preventDefault();
        self.updateQuantity(remove.getAttribute('data-line-key'), 0);
        return;
      }

      if (addRec) {
        event.preventDefault();
        self.addRecommendation(addRec.getAttribute('data-variant-id'));
        return;
      }

      if (mobileToggle) {
        var panel = self.root.querySelector('.tuftzy-mobile-summary');
        if (panel) panel.classList.toggle('is-open');
      }
    });

    if (this.elements.checkoutPrimary) {
      this.elements.checkoutPrimary.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.href = discountUrl(self.currentPromoCode());
      });
    }

    if (this.elements.continueShopping) {
      this.elements.continueShopping.addEventListener('click', function () {
        window.location.href = self.config.continue_shopping_url || '/collections/all';
      });
    }

    if (this.elements.promoInput) {
      this.elements.promoInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          self.applyPromo();
        }
      });
    }

    var promoButton = this.root.querySelector('[data-promo-apply]');
    if (promoButton) {
      promoButton.addEventListener('click', function (event) {
        event.preventDefault();
        self.applyPromo();
      });
    }
  };

  CartPage.prototype.currentPromoCode = function () {
    return (this.elements.promoInput && this.elements.promoInput.value.trim()) || this.promoCode || '';
  };

  CartPage.prototype.applyPromo = function () {
    this.promoCode = this.currentPromoCode().toUpperCase();
    if (!this.elements.promoStatus) return;
    this.elements.promoStatus.className = 'tuftzy-promo-status';

    if (!this.promoCode) {
      this.elements.promoStatus.textContent = 'Enter your code and it will be sent to checkout.';
      this.elements.promoStatus.classList.add('error');
      return;
    }

    this.elements.promoStatus.textContent = 'Your code will be applied when checkout opens.';
    this.elements.promoStatus.classList.add('success');
    this.renderSummary();
  };

  CartPage.prototype.setLoading = function (loading) {
    if (loading) this.root.classList.add('tuftzy-loading');
    else this.root.classList.remove('tuftzy-loading');
  };

  CartPage.prototype.updateQuantity = function (lineKey, quantity) {
    var self = this;
    this.setLoading(true);
    changeLine(lineKey, quantity)
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        self.cart = cart;
        self.render();
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  CartPage.prototype.addRecommendation = function (variantId) {
    var self = this;
    if (!variantId) return;
    this.setLoading(true);
    addVariant(variantId, 1)
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        self.cart = cart;
        self.render();
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  CartPage.prototype.renderItems = function () {
    var self = this;
    if (!this.elements.list || !this.cart) return;

    if (!this.cart.items || !this.cart.items.length) {
      this.elements.list.innerHTML = '<div class="tuftzy-empty"><h3>' + escapeHtml(this.config.empty_title || 'Your cart is feeling light') + '</h3><p>' + escapeHtml(this.config.empty_copy || 'Take another look at our handcrafted collection and come back when you are ready.') + '</p></div>';
      return;
    }

    this.elements.list.innerHTML = this.cart.items.map(function (item) {
      var compareAt = lineCompareAt(item);
      var image = lineImage(item);
      var variantText = lineVariantText(item);
      return '' +
        '<article class="tuftzy-cart-item">' +
          '<div class="tuftzy-item-media">' +
            '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title || item.title) + '">' +
            '<div class="tuftzy-cart-tag">' + escapeHtml(self.config.item_tag || 'Handcrafted') + '</div>' +
          '</div>' +
          '<div class="tuftzy-item-main">' +
            '<div class="tuftzy-item-head">' +
              '<div>' +
                '<h3 class="tuftzy-item-title">' + escapeHtml(item.product_title || item.title) + '</h3>' +
                '<div class="tuftzy-item-copy">' + escapeHtml(item.product_description || self.config.item_copy || 'Luxury comfort, hand-tufted support, and a beautifully finished sleep experience.') + '</div>' +
              '</div>' +
              '<div class="tuftzy-item-price">' + formatMoney(item.final_line_price || item.line_price || 0) + '</div>' +
            '</div>' +
            '<div class="tuftzy-chip-row">' +
  (variantText ? '<span class="tuftzy-cart-chip">' + escapeHtml(variantText) + '</span>' : '') +
  renderLineItemProperties(item.properties) +
  (compareAt ? '<span class="tuftzy-cart-chip success">You save ...' + '</span>' : '') +
'</div>' +
            '<div class="tuftzy-benefit-row">' + buildItemBenefits(self.config) + '</div>' +
            '<div class="tuftzy-delivery-note">' + escapeHtml(self.config.delivery_note || 'Estimated delivery timing is shown at checkout.') + '</div>' +
            '<div class="tuftzy-item-foot">' +
              '<div class="tuftzy-qty">' +
                '<button type="button" data-qty-minus data-line-key="' + escapeHtml(item.key) + '" data-next-quantity="' + Math.max(0, item.quantity - 1) + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-plus data-line-key="' + escapeHtml(item.key) + '" data-next-quantity="' + (item.quantity + 1) + '">+</button>' +
              '</div>' +
              '<button type="button" class="tuftzy-text-btn" data-remove-item data-line-key="' + escapeHtml(item.key) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');
  };

  CartPage.prototype.renderRecommendations = function () {
    var list = this.elements.recommendations;
    var recs = this.config.recommendations || [];
    if (!list) return;
    if (!recs.length) {
      list.innerHTML = '';
      return;
    }

    list.innerHTML = recs.map(function (item) {
      return '' +
        '<div class="tuftzy-rec-item">' +
          '<img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.title || '') + '">' +
          '<div>' +
            '<strong>' + escapeHtml(item.title || '') + '</strong>' +
            '<div class="tuftzy-rec-copy">' + escapeHtml(item.copy || '') + '<br>' + (item.price ? formatMoney(item.price) : '') + '</div>' +
          '</div>' +
          '<button type="button" class="tuftzy-product-button" data-add-recommendation data-variant-id="' + escapeHtml(item.variant_id || '') + '">Add</button>' +
        '</div>';
    }).join('');
  };

  CartPage.prototype.renderSummary = function () {
    if (!this.cart) return;
    var markup = renderSummaryMarkup(this.cart, this.currentPromoCode(), this.config);
    if (this.elements.summary) this.elements.summary.innerHTML = markup;
    if (this.elements.mobileSummary) this.elements.mobileSummary.innerHTML = markup;
    if (this.elements.heroTotal) this.elements.heroTotal.textContent = formatMoney(this.cart.total_price || 0);
    if (this.elements.mobileSummaryTotal) this.elements.mobileSummaryTotal.textContent = formatMoney(this.cart.total_price || 0);
    if (this.elements.monthly) this.elements.monthly.textContent = estimateMonthly(this.cart.total_price || 0, this.config.monthly_divisor || 24);
  };

  CartPage.prototype.render = function () {
    this.renderItems();
    this.renderSummary();
    this.renderRecommendations();
    document.dispatchEvent(new CustomEvent('tuftzy:cart-updated', { detail: { cart: this.cart } }));
  };

  function CartDrawer(root) {
    this.root = root;
    this.config = parseJsonScript(root, '[data-tuftzy-config]');
    this.cart = null;
    this.promoCode = '';
    this.overlay = root.querySelector('[data-drawer-overlay]');
    this.panel = root.querySelector('[data-drawer-panel]');
    this.items = root.querySelector('[data-drawer-items]');
    this.summary = root.querySelector('[data-drawer-summary]');
    this.countTargets = document.querySelectorAll('[data-tuftzy-cart-count]');
    this.totalTargets = document.querySelectorAll('[data-tuftzy-cart-total]');
    this.floatingWrap = root.querySelector('[data-floating-trigger-wrap]');
    this.bind();
  }

  CartDrawer.prototype.bind = function () {
    var self = this;

//     document.addEventListener('tuftzy:open-drawer', function () {
//   self.open();
// });

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-tuftzy-cart-open]');
      if (openTrigger) {
        event.preventDefault();
        self.open();
        return;
      }

      var closeTrigger = event.target.closest('[data-tuftzy-cart-close]');
      if (closeTrigger && self.root.contains(closeTrigger)) {
        event.preventDefault();
        self.close();
        return;
      }

      var minus = event.target.closest('[data-drawer-qty-minus]');
      var plus = event.target.closest('[data-drawer-qty-plus]');
      var remove = event.target.closest('[data-drawer-remove]');
      var addRec = event.target.closest('[data-drawer-add-recommendation]');
      var checkout = event.target.closest('[data-drawer-checkout]');
      var continueShopping = event.target.closest('[data-drawer-continue]');
      var promoApply = event.target.closest('[data-drawer-promo-apply]');
      var floatingTrigger = event.target.closest('[data-floating-trigger]');

      if (minus) {
        event.preventDefault();
        self.updateQuantity(minus.getAttribute('data-line-key'), Number(minus.getAttribute('data-next-quantity')));
        return;
      }

      if (plus) {
        event.preventDefault();
        self.updateQuantity(plus.getAttribute('data-line-key'), Number(plus.getAttribute('data-next-quantity')));
        return;
      }

      if (remove) {
        event.preventDefault();
        self.updateQuantity(remove.getAttribute('data-line-key'), 0);
        return;
      }

      if (addRec) {
        event.preventDefault();
        self.addRecommendation(addRec.getAttribute('data-variant-id'));
        return;
      }

      if (checkout) {
        event.preventDefault();
        window.location.href = discountUrl(self.currentPromoCode());
        return;
      }

      if (continueShopping) {
        event.preventDefault();
        self.close();
        return;
      }

      if (promoApply) {
        event.preventDefault();
        self.applyPromo();
        return;
      }

      if (floatingTrigger) {
        event.preventDefault();
        self.open();
      }
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', function () {
        self.close();
      });
    }

    var promoInput = this.root.querySelector('[data-drawer-promo-input]');
    if (promoInput) {
      promoInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          self.applyPromo();
        }
      });
    }

    document.addEventListener('tuftzy:cart-updated', function (event) {
      if (event.detail && event.detail.cart) {
        self.cart = event.detail.cart;
        self.render();
      }
    });
  };

  CartDrawer.prototype.currentPromoCode = function () {
    var input = this.root.querySelector('[data-drawer-promo-input]');
    return (input && input.value.trim()) || this.promoCode || '';
  };

  CartDrawer.prototype.applyPromo = function () {
    this.promoCode = this.currentPromoCode().toUpperCase();
    var status = this.root.querySelector('[data-drawer-promo-status]');
    if (!status) return;
    status.className = 'tuftzy-promo-status';
    if (!this.promoCode) {
      status.textContent = 'Enter your code and it will be sent to checkout.';
      status.classList.add('error');
      return;
    }
    status.textContent = 'Your code will be applied when checkout opens.';
    status.classList.add('success');
    this.renderSummary();
  };

  CartDrawer.prototype.setLoading = function (loading) {
    if (loading) this.root.classList.add('tuftzy-loading');
    else this.root.classList.remove('tuftzy-loading');
  };

  CartDrawer.prototype.open = function () {
    document.body.classList.add('tuftzy-drawer-open');
    if (this.panel) this.panel.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-visible');
  };

  CartDrawer.prototype.close = function () {
    document.body.classList.remove('tuftzy-drawer-open');
    if (this.panel) this.panel.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-visible');
  };

  CartDrawer.prototype.updateQuantity = function (lineKey, quantity) {
    var self = this;
    this.setLoading(true);
    changeLine(lineKey, quantity)
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        self.cart = cart;
        self.render();
        document.dispatchEvent(new CustomEvent('tuftzy:cart-updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  CartDrawer.prototype.addRecommendation = function (variantId) {
    var self = this;
    if (!variantId) return;
    this.setLoading(true);
    addVariant(variantId, 1)
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        self.cart = cart;
        self.render();
        self.open();
        document.dispatchEvent(new CustomEvent('tuftzy:cart-updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  CartDrawer.prototype.renderPayments = function () {
    var node = this.root.querySelector('[data-drawer-payment-badges]');
    var methods = (this.config.payment_methods || []).filter(function (item) { return item.enabled; });
    if (!node) return;
    if (!methods.length) {
      node.innerHTML = '';
      return;
    }

    node.innerHTML = methods.map(function (item) {
      return '<div class="tuftzy-drawer-payment-badge ' + escapeHtml(item.style || 'light') + '">' + escapeHtml(item.label || '') + '</div>';
    }).join('');
  };

  CartDrawer.prototype.renderFeatures = function () {
    var node = this.root.querySelector('[data-drawer-plugin-list]');
    var blocks = this.config.features || [];
    if (!node) return;
    node.innerHTML = blocks.map(function (block) {
      return '' +
        '<article class="tuftzy-plugin-card">' +
          '<div class="tuftzy-plugin-card-top">' +
            '<div>' +
              '<div class="tuftzy-plugin-eyebrow">' + escapeHtml(block.eyebrow || '') + '</div>' +
              '<strong>' + escapeHtml(block.title || '') + '</strong>' +
              '<div class="tuftzy-plugin-copy">' + escapeHtml(block.copy || '') + '</div>' +
            '</div>' +
            (block.action_label ? '<button type="button" class="tuftzy-drawer-mini-btn">' + escapeHtml(block.action_label) + '</button>' : '') +
          '</div>' +
        '</article>';
    }).join('');
  };

  CartDrawer.prototype.renderRecommendations = function () {
    var node = this.root.querySelector('[data-drawer-recommendations]');
    var recs = this.config.recommendations || [];
    if (!node) return;
    node.innerHTML = recs.map(function (item) {
      return '' +
        '<article class="tuftzy-rec-item">' +
          '<img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.title || '') + '">' +
          '<div>' +
            '<strong>' + escapeHtml(item.title || '') + '</strong>' +
            '<div class="tuftzy-rec-copy">' + escapeHtml(item.copy || '') + '<br>' + (item.price ? formatMoney(item.price) : '') + '</div>' +
          '</div>' +
          '<button type="button" class="tuftzy-drawer-mini-btn" data-drawer-add-recommendation data-variant-id="' + escapeHtml(item.variant_id || '') + '">Add</button>' +
        '</article>';
    }).join('');
  };

  CartDrawer.prototype.renderItems = function () {
    var self = this;
    if (!this.items || !this.cart) return;

    if (!this.cart.items || !this.cart.items.length) {
      this.items.innerHTML = '<div class="tuftzy-empty"><h3>' + escapeHtml(this.config.empty_title || 'Your cart is empty') + '</h3><p>' + escapeHtml(this.config.empty_copy || 'Add your favorite Tuftzy setup and come back when you are ready.') + '</p></div>';
      return;
    }

    this.items.innerHTML = this.cart.items.map(function (item) {
      var compareAt = lineCompareAt(item);
      return '' +
        '<article class="tuftzy-drawer-item">' +
          '<img src="' + escapeHtml(lineImage(item)) + '" alt="' + escapeHtml(item.product_title || item.title) + '">' +
          '<div>' +
            '<h4>' + escapeHtml(item.product_title || item.title) + '</h4>' +
            '<div class="tuftzy-item-copy">' + escapeHtml(self.config.item_copy || 'Luxury comfort, hand-tufted support, and a beautifully finished sleep experience.') + '</div>' +
            '<div class="tuftzy-drawer-chip-row">' +
  (lineVariantText(item) ? '<span class="tuftzy-drawer-chip">...' + '</span>' : '') +
  renderLineItemProperties(item.properties) +
  (compareAt ? '<span class="tuftzy-drawer-chip success">You save ...' + '</span>' : '') +
  buildItemBenefits(self.config) +
'</div>' +
            '<div class="tuftzy-drawer-shipping-note">' + escapeHtml(self.config.delivery_note || 'Estimated delivery timing is shown at checkout.') + '</div>' +
            '<div class="tuftzy-drawer-item-line">' +
              '<span class="tuftzy-drawer-price">' + formatMoney(item.final_line_price || item.line_price || 0) + '</span>' +
              '<div class="tuftzy-qty">' +
                '<button type="button" data-drawer-qty-minus data-line-key="' + escapeHtml(item.key) + '" data-next-quantity="' + Math.max(0, item.quantity - 1) + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-drawer-qty-plus data-line-key="' + escapeHtml(item.key) + '" data-next-quantity="' + (item.quantity + 1) + '">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="tuftzy-drawer-actions">' +
              '<button type="button" class="tuftzy-text-btn" data-drawer-remove data-line-key="' + escapeHtml(item.key) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');
  };

  CartDrawer.prototype.renderSummary = function () {
    if (!this.cart || !this.summary) return;
    this.summary.innerHTML = renderSummaryMarkup(this.cart, this.currentPromoCode(), this.config);
    var count = this.cart.item_count || 0;
    var total = formatMoney(this.cart.total_price || 0);
    this.countTargets.forEach(function (node) { node.textContent = count; });
    this.totalTargets.forEach(function (node) { node.textContent = total; });
    if (this.floatingWrap) {
      this.floatingWrap.classList.toggle('tuftzy-hidden', count === 0);
    }
  };

  CartDrawer.prototype.render = function () {
    this.renderItems();
    this.renderSummary();
    this.renderPayments();
    this.renderFeatures();
    this.renderRecommendations();
  };

  function initCartPages() {
    var nodes = document.querySelectorAll('[data-tuftzy-cart-page]');
    nodes.forEach(function (node) {
      var page = new CartPage(node);
      fetchCart().then(function (cart) {
        page.cart = cart;
        page.render();
      }).catch(function () {
        page.renderRecommendations();
      });
    });
  }

  function initDrawers() {
    var nodes = document.querySelectorAll('[data-tuftzy-cart-drawer-root]');
    nodes.forEach(function (node) {
      var drawer = new CartDrawer(node);
      fetchCart().then(function (cart) {
        drawer.cart = cart;
        drawer.render();
      }).catch(function () {
        drawer.renderPayments();
        drawer.renderFeatures();
        drawer.renderRecommendations();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartPages();
    initDrawers();
  });
})();
